import { FormattedMessage, useIntl } from 'react-intl';
import { Fragment, useEffect, useState } from 'react';
import { Spinner } from '../components/Spinner';
import useToastHandler from '../hooks/useToastHandler';
import { ToastWrap } from '../components/ToastWrap';
import { IPomReportCategoryData, IPomReportSubCategoryData } from '../util/DataModelInterface';
import * as reportApi from '../api/PomReport';
import parse from 'html-react-parser';
import { ListGroup } from 'react-bootstrap';
import { CategoryModal } from '../components/CategoryModal';
import { SubcategoryModal } from '../components/SubcategoryModal';

export const Categories = () => {
  const intl = useIntl();
  const lang = intl.locale;
  const { addToast } = useToastHandler();

  const [categories, setCategories] = useState([] as IPomReportCategoryData[]);
  const [categoriesState, setCategoriesState] = useState([] as IPomReportCategoryData[]);
  const [loading, setLoading] = useState(false);
  const [toastActive, setToastActive] = useState(false);
  const [toastHeader, setToastHeader] = useState("");
  const [toastText, setToastText] = useState("");
  const [toastType, setToastType] = useState("");
  const [categoryModalActive, setCategoryModalActive] = useState(false);
  const [categoryModalTitle, setCategoryModalTitle] = useState("");
  const [subcategoryAddNew, setSubcategoryAddNew] = useState(false);
  const [subcategoryData, setSubcategoryData] = useState({} as IPomReportSubCategoryData);
  const [subcategoryModalActive, setSubcategoryModalActive] = useState(false);
  const [subcategoryModalTitle, setSubcategoryModalTitle] = useState("");
  const [open, setOpen] = useState({} as {[x: number]: boolean});
  const [changedDetails, setChangedDetails] = useState({} as {[x: string]: boolean});
  const [categoriesStateClass, setCategoriesStateClass] = useState([] as IPomReportCategoryData[]);

  useEffect(() => {
    setLoading(true);
    refreshData()
    .finally(() => {
        setLoading(false);
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const refreshData = async (force: boolean = false) => {
      await reportApi.getCategories(force).then((data: any) => {
          if (data?.error) {
              addToast(data.error, 'categories', 'fetch');
          } else if (data) {
              // console.log("data: ", data);
              setCategories(data);
              let dataTmp = [] as IPomReportCategoryData[];
              data.forEach( (cat: IPomReportCategoryData, catIndex: number) => {
                dataTmp.push({...cat});
              });
              setCategoriesState(dataTmp);
              if (!force) {
                setCategoriesStateClass(data);
              }
          }
      });
  }

  const toggleOneDetailSections = (catIndex: number, e: any) => {
    if (open[catIndex] !== e.target.open) {
        setOpen({...open, [catIndex]: e.target.open});
    }
  }

  const setSavedStates = (code: string) => {
    let newCategories = [...categories] as any;
    let index = categories.findIndex((item) => item.code === code );
    const nextClass = [...categoriesStateClass];
    let tmpClasses = {...nextClass[index]} as any;
    Object.keys(tmpClasses).forEach((key: string) => {
      if (tmpClasses[key] === 'fieldchanged') {
        tmpClasses[key] = 'fieldsaved';
      }
    });
    nextClass[index] = tmpClasses;
    setCategoriesStateClass(nextClass);
    setCategories(newCategories);
    let dataTmp = [] as IPomReportCategoryData[];
    newCategories.forEach( (cat: IPomReportCategoryData) => {
        dataTmp.push({...cat});
    });
    setCategoriesState(dataTmp);
    setToastHeader(intl.formatMessage({id: 'categories.saved'}));
    setToastText("");
    setToastType('success');
    setToastActive(true);

    setChangedDetails({...changedDetails, [code]: false});
  }

  const saveCategory = async (code: string) => {
    setLoading(true);
    let cat = categories.find((item) => item.code === code ) as IPomReportCategoryData;
    let resp = await reportApi.modifyCategory(cat);
    if (resp?.error) {
      setToastHeader(intl.formatMessage({id: 'error.categories.save'}));
      setToastType('warning');
      setToastActive(true);
    } else {
      setSavedStates(code);
      await refreshData(true);
    }
    setLoading(false);
  }

  const updateCat = (event: { currentTarget: any; }, index: number) => {

    const target = event.currentTarget;
    let newCategories = [...categories] as any;
    let code = newCategories[index].code;
    newCategories[index][target.name] = target.value;

    let className = target.name + '_class';
    newCategories[index][className] = 'fieldchanged';
    setCategories(newCategories);
    setCategoriesStateClass([...newCategories]);
    setChangedDetails({...changedDetails, [code]: true});
  }

  const updateSubCat = (sub: IPomReportSubCategoryData) => {
    let newCategories = [...categories] as IPomReportCategoryData[];
    let cat = newCategories.find((item) => item.view_code === sub.category ) as IPomReportCategoryData;
    if (cat) {
      let code = cat.code;
      let subcat = cat.subs.find((item) => item.code === sub.code);
      if (subcat) {
        subcat.name_fi = sub.name_fi;
        subcat.name_se = sub.name_se;
        subcat.name_en = sub.name_en;
        subcat.description_fi = sub.description_fi ? sub.description_fi : "";
        subcat.description_se = sub.description_se ? sub.description_se : "";
        subcat.description_en = sub.description_en ? sub.description_en : "";
        subcat.fin = sub.fin;
        subcat.aland = sub.aland;
        subcat.b2b = sub.b2b;
        subcat.price = sub.price;
      } else {
        let subTmp = {
          code: sub.code,
          view_code: sub.view_code ? sub.view_code : sub.code,
          unit: sub.unit,
          name_fi: sub.name_fi,
          name_se: sub.name_se,
          name_en: sub.name_en,
          description_fi: sub.description_fi ? sub.description_fi : "",
          description_se: sub.description_se ? sub.description_se : "",
          description_en: sub.description_en ? sub.description_en : "",
          fin: sub.fin ? true : false,
          aland: sub.aland ? true : false,
          b2b: sub.b2b ? true : false,
          price: sub.price
        } as IPomReportSubCategoryData;
        // console.log("adding new sub", subTmp);
        cat.subs.push(subTmp);
      }
      setCategories(newCategories);
      setChangedDetails({...changedDetails, [code]: true});
    }
  }

  const editSubItem = (sub: IPomReportSubCategoryData) => {
    setSubcategoryAddNew(false);
    setSubcategoryModalTitle(intl.formatMessage({id: 'categories.subcategory.modify'}));
    setSubcategoryData(sub);
    setSubcategoryModalActive(true);
  }

  const newSubCategory = (code: string, title: any) => {
    setSubcategoryAddNew(true);
    setSubcategoryModalTitle(intl.formatMessage({id: 'categories.subcategory.add'}));
    setSubcategoryData({
      category: code,
      category_title: title,
      fin: true,
      aland: true,
      b2b: true
    } as IPomReportSubCategoryData);
    setSubcategoryModalActive(true);
  }

  const updateNewCat = (cat: IPomReportCategoryData) => {
    let catTmp = {
      code: cat.code,
      view_code: cat.code,
      active: true,
      name_fi: cat.name_fi,
      name_se: cat.name_se,
      name_en: cat.name_en,
      subs: []
    } as IPomReportCategoryData;

    setCategories( [
      ...categories, catTmp
    ]);
    setCategoriesState( [
      ...categories, catTmp
    ]);
    setCategoriesStateClass([...categories, catTmp]);
    setChangedDetails({...changedDetails, [cat.code]: true});
  }

  const newCategory = () => {
    setCategoryModalTitle(intl.formatMessage({id: 'categories.add.category'}));
    setCategoryModalActive(true);
  }

  const getSubCatItems = (sub: IPomReportSubCategoryData, index: number) => {
    let code = sub.code;
    let name = lang === "fi-FI" ? parse(sub.name_fi) : (lang === "en-GB" ? parse(sub.name_en) : parse(sub.name_se));
    let subUnit = sub.unit === "kpl" ? intl.formatMessage({id: 'unit.pieces'}) : sub.unit;

    return (
      <Fragment key={index}>

        <ListGroup.Item className="list-group-item d-flex flex-row">
          <span>
              {code} <strong>{name}</strong><br></br> <FormattedMessage id="categories.category.price"/>/{subUnit}
          </span>
          <span className="item-actions ms-auto">
          <button className="btn btn-link btn-edit" onClick={() => editSubItem(sub)}>
            <i className="me-2 fa fa-edit"></i>
            <FormattedMessage id="categories.edit"/>
          </button>
          </span>
        </ListGroup.Item>

      </Fragment>
    )
  }

  const getCatItems = (cat: IPomReportCategoryData, index: number) => {
    let code = cat.code;
    let originalCat = categoriesState.find((item) => item.code === code ) as IPomReportCategoryData;
    let catClass = categoriesStateClass.find((item) => item.code === code ) as IPomReportCategoryData;
    let title = lang === "fi-FI" ? parse(originalCat.name_fi) : (lang === "en-GB" ? parse(originalCat.name_en) : parse(originalCat.name_se));
    let viewCode = originalCat.view_code;

    return (
      <Fragment key={index}>
        <details open={open[index]} onToggle={(event) => toggleOneDetailSections(index, event)}>
          <summary className={ changedDetails[code] ? "changed" : "" }>
            <h2>
              {viewCode} {title}
            </h2>
          </summary>
          <div className="details-content">

            <div id="categorydetails2">

              <p className="details-info">
                <span className="key"><FormattedMessage id="categories.category.code"/></span>
                <span className="value">{viewCode}</span>
              </p>

              <div className="form-group">
                <label htmlFor="name_fi" className="form-label"><FormattedMessage id='categories.category.name_fi'/></label>
                <input id="name_fi" type="text" name="name_fi"
                  autoComplete="off" onChange={(e) => updateCat(e, index)}
                  className={"form-control " + catClass.name_fi_class} value={cat.name_fi}/>
              </div>

              <div className="form-group">
                <label htmlFor="name_se" className="form-label"><FormattedMessage id='categories.category.name_se'/></label>
                <input id="name_se" type="text" name="name_se"
                  autoComplete="off" onChange={(e) => updateCat(e, index)}
                  className={"form-control " + catClass.name_se_class} value={cat.name_se}/>
              </div>

              <div className="form-group">
                <label htmlFor="name_en" className="form-label"><FormattedMessage id='categories.category.name_en'/></label>
                <input id="name_en" type="text" name="name_en"
                  autoComplete="off" onChange={(e) => updateCat(e, index)}
                  className={"form-control " + catClass.name_en_class} value={cat.name_en}/>
              </div>

            </div>

            <div className="subproducts">
              <div className="heading d-flex flex-row align-items-center">
                <h3><FormattedMessage id={'categories.subcategory.title'}/></h3>
                <button className="btn btn-link btn-add" data-bs-toggle="modal" data-bs-target="#subproductModal"
                  onClick={() => newSubCategory(viewCode, title)}>
                  <i className="fa fa-plus me-2" aria-hidden="true"></i>
                  <FormattedMessage id={'categories.add.subcategory'}/>
                </button>
              </div>
              <ListGroup variant="flush">
                {cat.subs.map((sub, sindex) => {
                    sub.category = viewCode;
                    sub.category_title = title;
                    return getSubCatItems(sub, sindex)
                })}
              </ListGroup>
            </div>

          </div>

          <div className="form-buttons">
            <button type="button" className="btn btn-primary btn-save" disabled={!changedDetails[code]}
              onClick={(e) => saveCategory(code)}>
              <i className="fa fa-save me-2" aria-hidden="true"></i>
              <FormattedMessage id="button.save"/>
            </button>
          </div>

        </details>
      </Fragment>
    )
  }

  return (
    <>
      <Spinner active={loading} />
      <ToastWrap active={toastActive} heading={toastHeader} text={toastText} type={toastType} setActive={(active: boolean) => setToastActive(active)} />
      <CategoryModal
          active={categoryModalActive}
          modalId='categoryModal'
          onClose={() => setCategoryModalActive(false)}
          title={categoryModalTitle}
          confirmbutton={
            {
              name: intl.formatMessage({id: 'button.add'}),
              class: 'btn btn-primary',
              onClick: (cat) => { updateNewCat(cat); setCategoryModalActive(false) }
            }
          }
          />
      <SubcategoryModal
          isAddNew={subcategoryAddNew}
          active={subcategoryModalActive}
          modalId='subcategoryModal'
          onClose={() => setSubcategoryModalActive(false)}
          title={subcategoryModalTitle}
          data={subcategoryData}
          confirmbutton={
            {
              name: intl.formatMessage({id: 'button.add'}),
              class: 'btn btn-primary',
              onClick: (sub) => { updateSubCat(sub); setSubcategoryModalActive(false) }
            }
          }
          />
      <h1><FormattedMessage id={'categories.title'}/></h1>
      <p className="info">
          <i className="fa fa-info-circle me-2"></i>
          <FormattedMessage id="categories.title.info"/>
      </p>

      <div className="controls d-flex justify-content-end my-5 align-items-center">
        {/* <div className="search-group me-auto">
          <label className="form-control-label sr-only" htmlFor="search">Search:</label>
          <div className="input-group">
            <input className="form-control" type="text" id="search" name="search" value="" placeholder="Etsi nimellä tai tunnuksella"/>
            <div className="input-group-append">
              <button type="button" className="btn btn-default btn-search" aria-label="Hae"><i className="fa fa-search"></i></button>
            </div>
          </div>
        </div> */}
        <div>
          {/* <button className="btn btn-primary"  data-bs-toggle="modal" data-bs-target="#productUploadModal">
            <i className="fa fa-upload mr-2"></i>
            <FormattedMessage id={'categories.import.pricelist'}/>
          </button> */}
          <button className="btn btn-secondary"  data-bs-toggle="modal" data-bs-target="#productModal"
            onClick={newCategory}>
            <i className="fa fa-plus-circle mr-2"></i>
            <span> <FormattedMessage id={'categories.add.category'}/></span>
          </button>
        </div>
      </div>

      <div id="productsList">
        {categories.map((cat, index) =>
          getCatItems(cat, index))}
      </div>

    </>
  );
};